import React from 'react';

const PrivacyPolicyStyleCraftAI = () => {
  const containerStyle = {
    padding: '20px',
    marginTop: '60px',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
    backgroundColor: '#ffffff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  };

  const headerStyle = {
    color: '#111',
  };

  const paragraphStyle = {
    color: '#333',
  };

  const linkStyle = {
    color: '#007BFF',
    textDecoration: 'none',
  };

  const linkHoverStyle = {
    textDecoration: 'underline',
  };

  return (
    <div style={containerStyle}>
        <h1 style={headerStyle}>Privacy Policy</h1>
        <p style={paragraphStyle}><strong>Effective Date:</strong> 23.06.2025</p>

        <h2 style={headerStyle}>Information Collection and Use</h2>
        <p style={paragraphStyle}>At StyleCraft AI, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and share your data when you use our App.</p>
        <p style={paragraphStyle}>For a better experience while using our Software, we may require you to provide us with certain personally identifiable information. The information that we request will be retained by us and used as described in this privacy policy.</p>
        
        <h2 style={headerStyle}>Data Collection</h2>
        <p style={paragraphStyle}>We do not collect any personal data directly. However, the App integrates with third-party services that may collect data:</p>
        <ul>
            <li style={paragraphStyle}><a style={linkStyle} href="https://firebase.google.com/support/privacy"><strong>Firebase:</strong></a> For analytics, authentication, storage, functions and performance monitoring</li>
            <li style={paragraphStyle}><a style={linkStyle} href="https://www.revenuecat.com/privacy"><strong>RevenueCat:</strong></a> For subscription and in-app purchase management</li>
            <li style={paragraphStyle}><a style={linkStyle} href="https://policies.google.com/privacy"><strong>Google Play Services</strong></a></li>
            <li style={paragraphStyle}><a style={linkStyle} href="https://support.google.com/admob/answer/6128543"><strong>AdMob</strong></a></li>
        </ul>
        <p style={paragraphStyle}>These services may collect data such as:</p>
        <ul>
            <li style={paragraphStyle}>Device information</li>
            <li style={paragraphStyle}>Usage statistics</li>
            <li style={paragraphStyle}>Subscription details</li>
            <li style={paragraphStyle}>Internet Protocol ("IP") address</li>
            <li style={paragraphStyle}>Operating system version</li>
        </ul>

        <h2 style={headerStyle}>Face Detection & Photo Processing</h2>
        <p style={paragraphStyle}>StyleCraft AI uses facial recognition solely to detect the presence of a human face in a photo. This ensures that image manipulation features are only available when a person is present. Facial recognition is performed locally on the device and no facial data is collected, stored, or transmitted.</p>
        <p style={paragraphStyle}>When users apply AI effects, the selected photo is sent securely to our servers for temporary processing. As part of this process, the photo may be shared with trusted third-party AI providers, specifically <a style={linkStyle} href="https://openai.com/policies/privacy-policy/">OpenAI</a>, <a style={linkStyle} href="https://policies.google.com/privacy?hl=en">Google Gemini</a>, <a style={linkStyle} href="https://www.eachlabs.ai/privacy-policy">Eachlabs.ai</a>, <a style={linkStyle} href="https://fal.ai/privacy#UseOfInformation">FalAI</a> solely for the purpose of generating the requested effects. The photo is used only momentarily during processing and is not stored or retained afterward. No photo data is used for training purposes or shared beyond the processing task.</p>

        <h2 style={headerStyle}>Service Providers</h2>
        <p style={paragraphStyle}>We may employ third-party companies and individuals to:</p>
        <ul>
            <li style={paragraphStyle}>Facilitate our Software</li>
            <li style={paragraphStyle}>Provide the Software on our behalf</li>
            <li style={paragraphStyle}>Perform Software-related services</li>
            <li style={paragraphStyle}>Assist in analyzing how our Software is used</li>
        </ul>
        <p style={paragraphStyle}>These third parties have access to your Personal Information only to perform these tasks and are obligated not to disclose or use it for any other purpose.</p>
        <p style={paragraphStyle}>Regarding data retention, these third-party services generally retain personal data for as long as necessary to fulfill the purposes for which it was collected, to deliver their services, to comply with applicable legal requirements, to maintain security, prevent incidents, resolve disputes, and for other legitimate business purposes. The specific retention periods are governed by their respective privacy policies.</p>

        <h2 style={headerStyle}>Data Security</h2>
        <p style={paragraphStyle}>We take reasonable measures to protect your data from unauthorized access, but we cannot guarantee absolute security due to the inherent risks of digital data transmission.</p>

        <h2 style={headerStyle}>Links to Other Sites</h2>
        <p style={paragraphStyle}>This Software may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review their Privacy Policies. We have no control over and assume no responsibility for their content, privacy policies, or practices.</p>

        <h2 style={headerStyle}>Changes to this Policy</h2>
        <p style={paragraphStyle}>We may update this Privacy Policy from time to time. Significant changes will be communicated through the App or our website.</p>

        <h2 style={headerStyle}>Contact Us</h2>
        <p style={paragraphStyle}>If you have any questions about this Privacy Policy, please contact us at <a style={linkStyle} href="mailto:reecomgamestudio@gmail.com">reecomgamestudio@gmail.com</a>.</p>
    </div>
);
};

export default PrivacyPolicyStyleCraftAI;